export const LoadingComponent = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="center">
        <span className="cat-loader"></span>
      </div>
    );
  }
  return children;
};
